import { axiosAuthInstance, axiosInstance } from "../../../config/axios-config";

var ManualReceiptService = {
  getManualReceiptRecipients: async function (input) {
    return await axiosAuthInstance
      .get("/manual-receipts/recipients/recipients", {
        params: { ...input },
      })
      .then((res) => {
        return res.data;
      });
  },

  createManualReceiptRecipient: async function (input) {
    return await axiosAuthInstance
      .post("/manual-receipts/recipients", {
        ...input,
      })
      .then((res) => {
        return res.data;
      });
  },

  createManualReceipt: async function (input) {
    return await axiosAuthInstance
      .post("/manual-receipts", {
        ...input,
      })
      .then((res) => {
        return res.data;
      });
  },

  updateManualReceiptRecipient: async function (input) {
    return await axiosAuthInstance
      .put("/manual-receipts/recipients", {
        ...input,
      })
      .then((res) => {
        return res.data;
      });
  },

  deleteManualReceiptRecipient: async function (id, billerEntityId) {
    return await axiosAuthInstance
      .delete(`/manual-receipts/recipients/${id}`, {
        params: { billerEntityId },
      })
      .then((res) => {
        return res.data;
      });
  },

  publicManualReceiptDetailsById: async function (input) {
    return await axiosInstance
      .get(`/manual-receipts/reciepts/details`, {
        params: { ...input },
      })
      .then((res) => {
        return res.data;
      });
  },
};

export default ManualReceiptService;
